import { ApiClientMiddleware } from './api-client-middleware';

/**
 * Pre-middleware that sets `Accept-Language` from the caller-provided resolver. Apps wire it
 * to whatever drives their current language signal (e.g. `PlatformI18nService.resolveAcceptLanguage()`).
 *
 * The header is only added when the caller did not already set one, so per-request overrides
 * (e.g. localised label uploads) keep working.
 */
export function createLanguageMiddleware(
  resolveAcceptLanguage: () => string
): ApiClientMiddleware {
  return {
    pre: async (context) => {
      const headers = new Headers(context.init.headers);
      if (!headers.has('Accept-Language')) {
        headers.set('Accept-Language', resolveAcceptLanguage());
      }
      return { url: context.url, init: { ...context.init, headers } };
    },
  };
}
